import React, { useState } from "react";
import {
  FaClipboard,
  FaCheckCircle,
  FaCalendarAlt,
  FaClock,
} from "react-icons/fa";

const OrderIdCard = ({ order }) => {
  const [copied, setCopied] = useState(false);

  const orderId =
    order?.orderNumber ||
    order?._id ||
    "HF1753898568123";

  const orderDate = new Date(
    order?.createdAt || new Date()
  );

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(orderId);

      setCopied(true);

      setTimeout(() => {
        setCopied(false);
      }, 2000);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="order-id-card">

      <div className="order-id-header">

        <h3>Order Details</h3>

      </div>

      <div className="order-id-row">

        <span className="label">

          Order ID

        </span>

        <span className="value">

          {orderId}

        </span>

      </div>

      <div className="order-id-row">

        <span className="label">

          <FaCalendarAlt />

          Date

        </span>

        <span className="value">

          {orderDate.toLocaleDateString()}

        </span>

      </div>

      <div className="order-id-row">

        <span className="label">

          <FaClock />

          Time

        </span>

        <span className="value">

          {orderDate.toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
          })}

        </span>

      </div>

     

    </div>
  );
};

export default OrderIdCard;